const getActionTypesObject = (baseAction) => ({
  ERROR: `${baseAction}_ERROR`,
  INVOKE: baseAction,
  SUCCESS: `${baseAction}_SUCCESS`,
});

const FETCH_CURRENT_USER_DATA = 'FETCH_CURRENT_USER_DATA';
const FETCH_CURRENT_USER_META_DATA = 'FETCH_CURRENT_USER_META_DATA';
const FETCH_CURRENT_USER_PERMISSIONS_DATA = 'FETCH_CURRENT_USER_PERMISSIONS_DATA';
const FETCH_USER_DATA = 'FETCH_USER_DATA';

export const FETCH_CURRENT_USER = getActionTypesObject(FETCH_CURRENT_USER_DATA);
export const FETCH_CURRENT_USER_META = getActionTypesObject(FETCH_CURRENT_USER_META_DATA);
export const FETCH_CURRENT_USER_PERMISSIONS = getActionTypesObject(FETCH_CURRENT_USER_PERMISSIONS_DATA);
export const FETCH_USER = getActionTypesObject(FETCH_USER_DATA);
